import { Observable } from 'rxjs';
import { ModalidadeGarantia, LoteModalidadeGarantia, TipoEstiloMenuDTO, HistoricoModalidadeGarantia } from '../../model/modalidade_garantia.model';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { catchError } from 'rxjs/operators';
import { TaxaAtualizacaoGarantiaDTO, TipoContratoFichaCobrancaDTO, TipoOutraGarantia } from 'src/app/model/dominio-operacao.model';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { OperacaoCreditoLivreDominioIndexador } from 'src/app/model/operacao-credito-livre-dominio-indexador';
import { ModalidadeOperacionalCreditoLivre } from 'src/app/model/modalidade-operacional-credito-livre-model';
import { IndexadorAtualizacaoGarantiaCreditoLivre } from 'src/app/model/indexador-atualizacao-garantia-credito-livre';

@Injectable({
  providedIn:'root'
})
export class ModalidadeGarantiaService extends FgiBackEndService<ModalidadeGarantia> {


  getNewEntity() {
      return new ModalidadeGarantia();
  }

  protected getResourceURL(): string {
      return 'front';
  }


  public buscarTipoEstiloMenu(): Observable<Array<TipoEstiloMenuDTO>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/tipos`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<TipoEstiloMenuDTO>>;
  }

  public buscarModalidade(): Observable<ModalidadeGarantia> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<ModalidadeGarantia>;
  }

  public buscarModalidades(): Observable<LoteModalidadeGarantia> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/seguranca/todasModalidades`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<LoteModalidadeGarantia>;
  }

  public atualizarModalidade(dto: ModalidadeGarantia): Observable<ModalidadeGarantia> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/atualizar`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<ModalidadeGarantia>;
  }

  public salvarModalidade(dto: ModalidadeGarantia): Observable<ModalidadeGarantia> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<ModalidadeGarantia>;
  }

  public buscarHistoricoModalidade(idHistoricoModalidade: number): Observable<HistoricoModalidadeGarantia> {
    const options: any = blockUi()
    return this.http.get(`${this.BASE_URL}/historico/${idHistoricoModalidade}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<HistoricoModalidadeGarantia>;
  }

  public buscarPercentuaisGarantiaPermitidos(): Observable<ArrayBuffer> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/percentuaisGarantidos`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<ArrayBuffer>;
  }

  public buscarOutrasGarantiasPermitidas(): Observable<TipoOutraGarantia> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/outrasGarantias`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<TipoOutraGarantia>;
  }

  public buscarTiposOutrasGarantias(): Observable<TipoOutraGarantia> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/tiposOutrasGarantias`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<TipoOutraGarantia>;
  }

  public buscarTiposContratoFichaCobranca(): Observable<TipoContratoFichaCobrancaDTO> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/tiposContratoFichaCobranca`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<TipoContratoFichaCobrancaDTO>;
  }

  public buscarModalidadesInadimplenciaTecnica(): Observable<String[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/modalidadeInadimplenciaTecnica`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<String[]>;
  }

  public buscarModalidadesInadimplenciaFinanceira(): Observable<String[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/modalidadeInadimplenciaFinanceira`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<String[]>;
  }

  public buscarModalidadesInadimplenciaBeneficiario(): Observable<String[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/modalidadeInadimplenciaBeneficiario`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<String[]>;
  }

  public carregaHistoricosModalidade(): Observable<HistoricoModalidadeGarantia[]> {
    const options: any = blockUi()
    return this.http.get(`${this.BASE_URL}/historico`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public salvarPercentualGarantido(listaPercentuaisGarantidos: number[]): Observable<ArrayBuffer> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/adicionarPercentuaisGarantidos`, listaPercentuaisGarantidos, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<ArrayBuffer>;
  }

  public salvarGarantia(listaOutrasGarantiasPermitidas: TipoOutraGarantia[]): Observable<TipoOutraGarantia[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/adicionarOutrasGarantias`, listaOutrasGarantiasPermitidas, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<TipoOutraGarantia[]>;
  }

  public salvarModalidadeInadimplenciaTecnica(listaSiglaModalidadeValidacao: string[]): Observable<string[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/adicionarModalidadeInadimplenciaTecnica`, listaSiglaModalidadeValidacao, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<string[]>;
  }

  public salvarModalidadeInadimplenciaFinanceira(listaSiglaModalidadeValidacao: string[]): Observable<string[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/adicionarModalidadeInadimplenciaFinanceira`, listaSiglaModalidadeValidacao, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<string[]>;
  }

  public salvarModalidadeInadimplenciaBeneficiario(listaSiglaModalidadeValidacao: string[]){
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/adicionarModalidadeInadimplenciaBeneficiario`, listaSiglaModalidadeValidacao, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<string[]>;
  }

  public salvarTaxaAtualizacaoGarantia(dados: any): Observable<any> {
    const options: any = blockUi();
    return this.http.post<any>(`${this.BASE_URL}/indexadores-atualizacao-garantia/salvar`, dados, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public buscarTaxasAtualizacaoGarantia(params: any): Observable<ResultadoPaginado<TaxaAtualizacaoGarantiaDTO>> {
    return this.http.get<ResultadoPaginado<TaxaAtualizacaoGarantiaDTO>>(`${this.BASE_URL}/indexadores-atualizacao-garantia`,
      { params: params }).pipe(catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public buscarIndexadores(): Observable<OperacaoCreditoLivreDominioIndexador[]> {
    return this.http.get<OperacaoCreditoLivreDominioIndexador[]>(`${this.BASE_URL}/indexadores-atualizacao-garantia/indexadores`).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public encerrarTaxaAtualizacaoGarantia(idTag: number, dataFinalValidade: Date): Observable<any> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/indexadores-atualizacao-garantia/encerrar`, {idTag: idTag, dataFinalValidade: dataFinalValidade}, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public excluirTaxaAtualizacaoGarantia(idTag: number): Observable<any> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/indexadores-atualizacao-garantia/excluir/${idTag}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public buscarModalidadesOperacionais(): Observable<ModalidadeOperacionalCreditoLivre[]> {
    return this.http.get<ModalidadeOperacionalCreditoLivre[]>(`${this.BASE_URL}/indexadores-atualizacao-garantia/modalidades-operacionais`).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }
}
